import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";

export default function Results() {
  const { t, lang } = useI18n();
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/settings").then(r => setStats(r.data?.stats || {})).catch(() => {}); }, []);
  const total = Object.values(stats).reduce((a, b) => a + (Number(b) || 0), 0);
  const labels = t("results.labels");
  return (
    <div data-testid="results-page">
      <section className="hero-gradient py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-warm-orange font-semibold">{t("pages.results.tag")}</div>
          <h1 className="font-display text-deep-blue text-5xl sm:text-6xl lg:text-7xl leading-tight mt-3">{t("pages.results.t1")}<br/><span className="italic text-warm-orange">{t("pages.results.t2")}</span></h1>
        </div>
      </section>
      <section className="py-16 deep-section">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          {total === 0 && (
            <div className="mb-10 p-6 rounded-xl bg-white/5 border border-white/10 text-ivory/80">
              <span className="text-gold font-semibold">{t("results.launchBanner")}</span> {t("results.launchText")}
            </div>
          )}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {Object.entries(labels).map(([k, l], i) => (
              <div key={k} className="p-6 rounded-2xl bg-white/5 border border-white/10 backdrop-blur" data-testid={`result-${k}`}>
                <div className="font-display text-5xl text-gold">{stats[k] ?? 0}</div>
                <div className="text-ivory mt-2 text-sm">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
